import { useState } from "react";

export function useSwitch(initialState: boolean): [boolean, { on: () => any, off: () => any }] {
    const [flag, setFlag] = useState(initialState);

    const on = () => { setFlag(true); };
    const off = () => { setFlag(false); };

    return [
        flag,
        { on, off }
    ]
}